import React, { useMemo } from 'react';
import {
  FilterContainer,
  FilterAndSortContainer,
  Frame5086,
  Frame5086Img,
  Frame5086Text,
} from './style';
import RoundedDropDown from '../../components2/RoundedDropDown';
import SortItems from '../../components2/SortItems';
import FilterSquare from '../../static/img/filter-square.svg';

const getSubjectFromItem = (item) => {
  const sub = item?.assignment?.subjects?.[0];
  if (sub && typeof sub === 'object') return sub.subjectName || sub.title || sub.subjectCode || sub.code || '';
  return item?.assignment?.subjectCode || item?.assignment?.subjectName || item?.subjectCode || item?.subject || '';
};

export const getFilterOptionsFromItems = (items = []) => {
  const stateSet = new Set();
  const yearSet = new Set();
  const subjectSet = new Set();
  const documentTypeSet = new Set();
  const responseTypeSet = new Set();
  (items || []).forEach((item) => {
    const state = item.state || '';
    if (state) stateSet.add(state);
    const year = item.year ?? item?.assignment?.year;
    if (year != null && year !== '') yearSet.add(String(year));
    const sub = getSubjectFromItem(item);
    if (sub) subjectSet.add(sub);
    const docType = item.documentType || item?.assignment?.type || item?.assignment?.taskType || '';
    if (docType) documentTypeSet.add(docType);
    const respType = item?.assignment?.responseType || item?.responseType || '';
    if (respType) responseTypeSet.add(respType);
  });
  const years = Array.from(yearSet).sort((a, b) => (Number(b) || 0) - (Number(a) || 0));
  return {
    statesOptions: Array.from(stateSet).sort(),
    yearsOptions: years.map(String),
    subjectOptions: Array.from(subjectSet).sort(),
    documentTypeOptions: Array.from(documentTypeSet).sort(),
    responseTypeOptions: Array.from(responseTypeSet).sort(),
  };
};

const FeedbackFilters = ({
  items = [],
  selectedState,
  selectedYear,
  selectedDocumentType,
  selectedSubject,
  selectedResponseType,
  sortItem,
  onFilterChange,
  onSortChange,
}) => {
  const { statesOptions, yearsOptions, subjectOptions, documentTypeOptions, responseTypeOptions } = useMemo(
    () => getFilterOptionsFromItems(items),
    [items]
  );

  const handleFilterChange = (type, value) => onFilterChange(type, value);

  return (
    <FilterAndSortContainer>
      <FilterContainer>
        <Frame5086>
          <Frame5086Img src={FilterSquare} />
          <Frame5086Text>Filters:</Frame5086Text>
        </Frame5086>
        {statesOptions.length > 0 && (
          <RoundedDropDown search={false} type="state" selectedIndex={handleFilterChange} menuItems={statesOptions} width={90} value={selectedState} />
        )}
        {yearsOptions.length > 0 && (
          <RoundedDropDown search={false} type="year" selectedIndex={handleFilterChange} menuItems={yearsOptions} width={90} value={selectedYear} />
        )}
        {subjectOptions.length > 0 && (
          <RoundedDropDown search={false} type="subject" selectedIndex={handleFilterChange} menuItems={subjectOptions} width={120} value={selectedSubject} />
        )}
        {documentTypeOptions.length > 0 && (
          <RoundedDropDown search={false} type="documentType" selectedIndex={handleFilterChange} menuItems={documentTypeOptions} width={130} value={selectedDocumentType} />
        )}
        {responseTypeOptions.length > 0 && (
          <RoundedDropDown search={false} type="responseType" selectedIndex={handleFilterChange} menuItems={responseTypeOptions} width={130} value={selectedResponseType} />
        )}
      </FilterContainer>
      <SortItems sortItem={sortItem} setSortItem={onSortChange} firstSortText="New to Old" secondSortText="Old to New" />
    </FilterAndSortContainer>
  );
};

export default FeedbackFilters;